import { render, staticRenderFns } from "./import-sisterQuestionUs.vue?vue&type=template&id=30deb939&scoped=true&"
import script from "./import-sisterQuestionUs.vue?vue&type=script&lang=ts&"
export * from "./import-sisterQuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./import-sisterQuestionUs.vue?vue&type=style&index=0&id=30deb939&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30deb939",
  null
  
)

export default component.exports